import React, { useState } from "react";
import { formatSecondsToMMSS } from "../../StartVoteWindow/helper";
import style from "./voteButtonTimer.module.css";

type VoteButtonTimerProps = {
    startedAt: string;
    duration: number;
    onUnmount: () => void;
};

export function VoteButtonTimer({ startedAt, duration, onUnmount }: VoteButtonTimerProps) {
    const startedMS = new Date(startedAt).getTime();
    const durationMS = duration * 1000;
    const finishAt = startedMS + durationMS;
    const currentDate = Date.now();

    const [pastAsSeconds, setPastAsSeconds] = useState((finishAt - currentDate) / 1000);

    const interval = setInterval(() => {
        const currentDateMS = Date.now();
        const diffMS = finishAt - currentDateMS;

        if (diffMS < 0) {
            onUnmount();
            clearInterval(interval);
        } else {
            setPastAsSeconds(diffMS / 1000);
        }
    }, 1000);

    return <div className={style.timerWrapper}>{formatSecondsToMMSS(pastAsSeconds)}</div>;
}
